<template>
	<span
		v-if="disabled"
		:class="classes"
	>
		<Icon class="left-icon" :icon="icon" />
		{{ text }}
	</span>
	<a
		v-else
		:class="classes"
		:href="href ? href : '#'"
		@click="onClick"
	>
		<Icon class="left-icon" :icon="icon" :size="iconSize" />
		{{ text }}
	</a>
</template>

<script>
import Icon from "@/vue/icon/Icon";

export default {

	components: {
		Icon,
	},

	props: {
		icon: {
			type: String,
			required: true,
		},
		text: {
			type: String,
			required: true,
		},
		iconSize: {
			type: String,
			required: false,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		href: {
			type: String,
			required: false,
		}
	},

	computed: {
		classes ()
		{
			let classes = ['icon-link' ];

			if (this.disabled)
			{
				classes.push('disabled');
			}

			return classes;
		},
	},

	methods: {
		onClick (e)
		{
			if (!this.href)
			{
				e.preventDefault();

				this.$emit('click');
			}
		}
	}
}
</script>
